export default __webpack_public_path__ + "static/media/cau-norm-en-lilagrey-cmyk.eaa60b24.png";